module.exports = __webpack_public_path__ + "static/media/GESSTwoLight-Light.98d9fbff.ttf";